export const hostnameBySiteId = {
  ZJAR: 'zonajobs.com.ar',
  BMAR: 'bumeran.com.ar',
  BMCL: 'laborum.cl',
  BMEC: 'multitrabajos.com',
  BMMX: 'bumeran.com.mx',
  BMPA: 'konzerta.com',
  BMPE: 'bumeran.com.pe',
  BMVE: 'bumeran.com.ve',
}
